/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * 包含待加密文本 'text' 和密钥 'key' 的JSON对象
 */
export type PostTextAesEncryptRequest = { key: string; text: string };

export const PostTextAesEncryptRequest$zodSchema: z.ZodType<
  PostTextAesEncryptRequest
> = z.object({
  key: z.string(),
  text: z.string(),
}).describe("包含待加密文本 'text' 和密钥 'key' 的JSON对象");

export type PostTextAesEncryptInternalServerErrorDetails = {};

export const PostTextAesEncryptInternalServerErrorDetails$zodSchema: z.ZodType<
  PostTextAesEncryptInternalServerErrorDetails
> = z.object({});

/**
 * 加密失败
 */
export type PostTextAesEncryptInternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: PostTextAesEncryptInternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const PostTextAesEncryptInternalServerErrorResponseBody$zodSchema:
  z.ZodType<PostTextAesEncryptInternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() =>
      PostTextAesEncryptInternalServerErrorDetails$zodSchema
    ).optional(),
    message: z.string().optional(),
  }).describe("加密失败");

export type PostTextAesEncryptBadRequestDetails = {};

export const PostTextAesEncryptBadRequestDetails$zodSchema: z.ZodType<
  PostTextAesEncryptBadRequestDetails
> = z.object({});

/**
 * 无效的请求参数
 */
export type PostTextAesEncryptBadRequestResponseBody = {
  code?: string | undefined;
  details?: PostTextAesEncryptBadRequestDetails | undefined;
  message?: string | undefined;
};

export const PostTextAesEncryptBadRequestResponseBody$zodSchema: z.ZodType<
  PostTextAesEncryptBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => PostTextAesEncryptBadRequestDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("无效的请求参数");

/**
 * 成功响应
 */
export type PostTextAesEncryptResponseBody = {
  ciphertext?: string | undefined;
};

export const PostTextAesEncryptResponseBody$zodSchema: z.ZodType<
  PostTextAesEncryptResponseBody
> = z.object({
  ciphertext: z.string().optional(),
}).describe("成功响应");

export type PostTextAesEncryptResponse =
  | PostTextAesEncryptResponseBody
  | PostTextAesEncryptBadRequestResponseBody
  | PostTextAesEncryptInternalServerErrorResponseBody;

export const PostTextAesEncryptResponse$zodSchema: z.ZodType<
  PostTextAesEncryptResponse
> = z.union([
  z.lazy(() => PostTextAesEncryptResponseBody$zodSchema),
  z.lazy(() => PostTextAesEncryptBadRequestResponseBody$zodSchema),
  z.lazy(() => PostTextAesEncryptInternalServerErrorResponseBody$zodSchema),
]);
